import { createContext as t } from "react";
const e = () => {
}, r = t({
  alert: e,
  inform: e,
  clearAll: e
});
export {
  r as default
};
